import { BACKUP_MAP_INFO, RESET_MAP_INFO } from './types'

export const backupMap = payload => dispatch => {
  dispatch({ type: BACKUP_MAP_INFO, payload })
}

export const resetMap = () => dispatch => {
  dispatch({ type: RESET_MAP_INFO })
}
